import { render, staticRenderFns } from "./DebateContributions.vue?vue&type=template&id=62d675c2&scoped=true&"
import script from "./DebateContributions.vue?vue&type=script&lang=js&"
export * from "./DebateContributions.vue?vue&type=script&lang=js&"
import style0 from "./DebateContributions.vue?vue&type=style&index=0&id=62d675c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d675c2",
  null
  
)

export default component.exports